<template>
  <b-modal
    modal-class="confirmBuyModal"
    id="confirmBuyModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="areYouSureModalLabel"
    aria-hidden="true"
    hide-footer
    hide-header
    no-close-on-backdrop
    ref="confirm-modal"
    size="lg"
  >
    <div class="modal-body">
      <h4 class="text-center" data-lang-name="buying_title">{{ translate('buying_title')}}</h4>
      <div class="row">
        <div class="col-md-6">
          <b-button class="custom-cancel-buying" variant="outline-danger" block @click="hideModal">
            {{ getDisabledConfirm ? translate('exit') : translate('cancel_buying') }}
          </b-button>
        </div>
        <div class="col-md-6">
          <b-button :class="getDisabledConfirm ? 'custom-confirm-buying-disabled' : 'custom-confirm-buying'" variant="outline-warning" block @click="confirmBuy">{{ translate('confirm_buying') }}</b-button>
        </div>
      </div>
      <hr/>
      <div class="row">
          <h4 class="m-auto">{{ translate('total_stake') }} : {{ ticketAmount && ticketAmount.toFixed(2) }} {{ getMainConfig.Currency }} </h4>
      </div>
      <div class="row" v-if="getDisabledConfirm">
          <h5 class="pt-2 m-auto text-danger">{{  translate('ticket_is_processing') }}</h5>
      </div>
    </div>
  </b-modal>
</template>

<script>
import $eventBus from '../../../eventBus';
import {translate} from '../../../assets/common/lang';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      buying_title: translate('buying_title'),
      confirm_buying: translate('confirm_buying'),
      cancel_buying: translate('cancel_buying'),
      ticketAmount: 0
    };
  },
  methods: {
    hideModal() {
      this.$refs['confirm-modal'].hide();
      this.$store.dispatch("setQuickReplayDisabled", false);
      $eventBus.$emit(`cancelLuckyBallsTicketBuy`);
    },
    translate(word) {
      return translate(word);
    },
    confirmBuy() {
      if (!this.getDisabledConfirm) {
        this.$store.dispatch("setDisabledConfirm", true);
        $eventBus.$emit(`disabledConfirmTimeout`);
        $eventBus.$emit(`confirmLuckyBallsTicketBuy`);
      }
    }
  },
  computed: {
    ...mapGetters(["getMainConfig", "getDisabledConfirm"])
  },
  mounted() {
    this.buying_title = translate('buying_title');
    this.confirm_buying = translate('confirm_buying');
    this.cancel_buying = translate('cancel_buying');
    $eventBus.$on("enableConfirmButton", () => {
      this.$refs['confirm-modal'].hide();
    });
    $eventBus.$on("hideConfirmModal", () => {
      this.$refs['confirm-modal'].hide();
    });
    $eventBus.$on("setTicketAmount", (amount) => {
      this.ticketAmount = amount;
    });
  },
  beforeDestroy() {
    $eventBus.$off(`confirmLuckyBallsTicketBuy`);
    $eventBus.$off(`cancelLuckyBallsTicketBuy`);
    $eventBus.$off(`enableConfirmButton`);
    $eventBus.$off(`hideConfirmModal`);
    $eventBus.$off(`setTicketAmount`);
    this.ticketAmount = 0; 
    clearTimeout(this.disabledConfirmTimeout);
   },
};
</script>
